import router from '@/router'
import { message } from 'ant-design-vue'
import imageView from '@/views/components/uploadFile/imageView.vue'
import { createVNode, render  } from 'vue'

/**
 * 工具集
 */
const tool = {}

// 本地存储localStorage
tool.data = {
	set(table, settings) {
		const _set = JSON.stringify(settings)
		return localStorage.setItem(table, _set)
	},
	get(table) {
		let data = localStorage.getItem(table)
		try {
			data = JSON.parse(data)
		} catch (err) {
			return null
		}
		return data
	},
	remove(table) {
		return localStorage.removeItem(table)
	},
	clear() {
		return localStorage.clear()
	}
}

// 会话存储SessionStorage
tool.session = {
	set(table, settings) {
		const _set = JSON.stringify(settings)
		return sessionStorage.setItem(table, _set)
	},
	get(table) {
		let data = sessionStorage.getItem(table)
		try {
			data = JSON.parse(data)
		} catch (err) {
			return null
		}
		return data
	},
	remove(table) {
		return sessionStorage.removeItem(table)
	},
	clear() {
		return sessionStorage.clear()
	}
}

// 千分符
tool.groupSeparator = (num) => {
	num = `${num}`
	if (!num.includes('.')) num += '.'

	return num
		.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
			return `${$1},`
		})
		.replace(/\.$/, '')
}

// 获取年
tool.getAge = (birthday) => {
	if (!birthday) return ''
	let returnAge;
	let strBirthdayArr = birthday.split("-");
	let birthYear = strBirthdayArr[0];
	let birthMonth = strBirthdayArr[1];
	let birthDay = strBirthdayArr[2];

	let d = new Date();
	let nowYear = d.getFullYear();
	let nowMonth = d.getMonth() + 1;
	let nowDay = d.getDate();

	if (nowYear == birthYear) {
		returnAge = 0;  //同年 则为0岁
	}
	else {
		var ageDiff = nowYear - birthYear; //年之差
		if (ageDiff > 0) {
			if (nowMonth == birthMonth) {
				var dayDiff = nowDay - birthDay;//日之差
				if (dayDiff < 0) {
					returnAge = ageDiff - 1;
				}
				else {
					returnAge = ageDiff;
				}
			}
			else {
				var monthDiff = nowMonth - birthMonth;//月之差
				if (monthDiff < 0) {
					returnAge = ageDiff - 1;
				}
				else {
					returnAge = ageDiff;
				}
			}
		}
		else {
			returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
		}
	}
	return returnAge;   //返回周岁年龄
}

// 金额转换k为单位 （3000 => 3k）
tool.amountTranslation = (num) => {
	if (!num) return ''
	return Math.round(num / 1000) + "K"
}

// 获取所有字典数组
tool.dictDataAll = () => {
	return tool.data.get('DICT_TYPE_TREE_DATA')
}
// 字典翻译方法，界面插槽使用方法 {{ $TOOL.dictType('sex', record.sex) }}
tool.dictTypeData = (dictValue, value) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		return '需重新登录'
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (!tree) {
		return '无此字典'
	}
	const children = tree.children
	const dict = children.find((item) => item.dictValue === value)
	return dict ? dict.dictLabel : ''
}
// 获取某个code下字典的列表，基于dictTypeList 改进，保留老的，逐步替换
tool.dictList = (dictValue) => {
	const dictTypeTree = tool.dictDataAll()
	// console.log('查找字典：', dictTypeTree)
	if (!dictTypeTree) {
		return []
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (tree) {
		return tree.children.map((item) => {
			return {
				value: item['dictValue'],
				label: item['name']
			}
		})
	}
	return []
}

// 获取字典列表(用于下拉框)
tool.dictOptions = (dictValue) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		return []
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (tree) {
		return tree.children.map((item) => {
			return {
				value: item['id'],
				label: item['dictLabel'],
				isDefault: item['isDefault']
			}
		})
	}
	return []
}
// 获取字典列表(用于下拉框)(使用dictValue做value)
tool.dictOptions2 = (dictValue) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		return []
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (tree) {
		return tree.children.map((item) => {
			return {
				value: item['dictValue'],
				label: item['dictLabel']
			}
		})
	}
	return []
}
// 字典翻译方法，界面插槽使用方法 {{ $TOOL.dictType('sex', record.sex) }}
tool.translateDict = (dictValue, id) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		return '需重新登录'
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (!tree) {
		return '无此字典'
	}
	const children = tree.children
	const dict = children.find((item) => item.id == id)
	return dict ? dict.dictLabel : ''
}
/**
 * 翻译地区 DICT_DISTRICT 职位 DICT_JOB 专业 DICT_MAJOR 树形字典
 * dictKey：字典key（DICT_DISTRICT | DICT_JOB | DICT_MAJOR）
 * id: 当前级id
 */
tool.translateTree = (dictKey, id) => {
	const tree = tool.data.get(dictKey)
	const targetNode = findNodeById(tree, id)
	return targetNode ? targetNode.name : ''
}
const findNodeById = (node, id) => {
	for (const item of node) {
		if (item.id == id) return item
		if (item.children && item.children.length>0) {
		  const _item = findNodeById(item.children, id)
		  if (_item) return _item
		}
	}
}

// 附件预览
tool.previewFile = (file) => {
	let typeList = ['png','jpg','jpeg','pdf','PDF']
	if (!typeList.includes(file.suffix)) return message.warning('该文件类型不支持预览')
	if (file.suffix === 'pdf' || file.suffix === 'PDF') {
		const url = router.resolve({
			path: '/filePreview',
			query: {
				src: file.url,
				fileType: file.suffix
			}
		})
		window.open(url.href, '_blank')
	} else {
		render(createVNode(imageView, { visible: true, url: file.url  }), document.createDocumentFragment())
	}
}

// 附件下载
tool.downloadFile = (file) => {
	let x = new XMLHttpRequest()
	x.open('GET', file.url, true)
	x.responseType = 'blob'
	x.onload = function() {
		let url = window.URL.createObjectURL(x.response)
		let a = document.createElement('a')
		a.href = url
		a.download = file.name
		a.click()
	}
	x.send()
}

// 打开新浏览器窗口
tool.windowOpen = (path, query) => {
	const url = router.resolve({ path, query })
	window.open(url.href, '_blank')
}


// 获取assets登录页图片
tool.getLoginImgUrl = (fileName) => {
	return new URL(`../assets/login/${fileName}`, import.meta.url).href
}

export default tool
